import { hasRequestedAccessFeature } from 'helpers/RoleHelper';
import { Activity as Feature } from '../../config/Features';

const userHasActivityAccessFeature = () => {
  return hasRequestedAccessFeature(Feature);
};

// eslint-disable-next-line import/prefer-default-export
export { userHasActivityAccessFeature };
